var _jsxFileName = "/repo/packages/ippm/src/components/BackToSurvey/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { IconArrowLeft } from '@sm/wds-icons';
import { Button } from '@sm/wds-react';
import { logIPPMInteraction } from '../../utils/logger';
import { useAppContext } from '../../utils/appContext';
import './BackToSurvey.scss';
var BackToSurvey = function BackToSurvey(_ref) {
  var onBackToSurveyClick = _ref.onBackToSurveyClick;
  var appContext = useAppContext();
  return /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "link",
    onClick: function onClick() {
      logIPPMInteraction('popup_close', 'back_to_survey_cta');
      onBackToSurveyClick();
    },
    className: "wds-p-0 bts-button",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconArrowLeft, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "wds-m-l-1 link-text",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, appContext.getString('back_to_survey')));
};
BackToSurvey.propTypes = {
  onBackToSurveyClick: PropTypes.func.isRequired
};
export default BackToSurvey;